export * from './evento-prestacao-conta.component';
export * from './crud/evento-prestacao-conta-crud.component';
export * from './crud/etapas/evento-prestacao-conta-etapa1.component';
export * from './crud/etapas/evento-prestacao-conta-etapa2.component';
export * from './crud/etapas/evento-prestacao-conta-etapa3.component';
export * from './crud/etapas/evento-prestacao-conta-etapa4.component';
export * from './crud/etapas/evento-prestacao-conta-etapa5.component';


// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/index.ts